import { BasePromoCodeListResponse, BasePromoCodeResponse, BaseResponse } from '@api/backend';
import { Observable } from 'rxjs';

export abstract class PromoCodeRepository {

  public abstract getList(): Observable<BasePromoCodeListResponse>;

  public abstract getValidatePromoCode(promoCode: string): Observable<BasePromoCodeResponse>;

  public abstract postApplyPromoCode(promoCode: string): Observable<BaseResponse>;
}